import { AnalyticsEventName, MaskGroup } from '@/shared/config';

export const MASK_TOOLTIP_X_SHIFT = 15;
export const MASK_TOOLTIP_Y_SHIFT = 15;

// Must match --transition-time: the outgoing block plays fadeOut for exactly
// this long before it is unmounted and the incoming one mounts.
export const TOP_BAR_TRANSITION_TIME = 300;

export const MASK_FILTER_EVENT_MAPPING: Record<MaskGroup, AnalyticsEventName> =
  {
    perio: 'ReportPagePanoramaPerioButtonClicked',
    restorative: 'ReportPagePanoramaRestorativeButtonClicked',
    endo: 'ReportPagePanoramaEndoButtonClicked',
    chart: 'ReportPagePanoramaAnatomyButtonClicked',
  };
